module.exports = "<div class=\"resource-item-content resource-reel-item\">\r\n    <div id=\"resource-logo\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/partials/overview-resource-logo.html
// module id = 381
// module chunks = 1